<template>
  <!-- Keep the two heavy, image-rich screens alive so their already-rendered DOM
       (with decoded <img>s) is reused on return instead of being rebuilt — this
       stops the hero / dish images from re-decoding and flashing on navigation.
       Scoped via :include so lighter routes (cart, tip, review…) still mount fresh. -->
  <keep-alive :include="['Welcome', 'MenuTabNew']">
    <router-view />
  </keep-alive>
</template>

<script>
import { mapGetters } from 'vuex'
import { brandThemeCss } from '@/utils/colorTheme'
import applyHead from '@/utils/head'

export default {
  name: 'App',

  computed: {
    ...mapGetters(['getCustomCSS', 'getBrandColor', 'getCompanyData']),
  },

  watch: {
    getCustomCSS: {
      immediate: true,
      handler() {
        this.applyTheme()
      },
    },
    getBrandColor: {
      immediate: true,
      handler() {
        this.applyTheme()
      },
    },
    getCompanyData: {
      // Venue data arrives async after the QR loading flow — refresh title/meta/OG
      // with the real venue name, photo and brand colour once it does.
      handler() {
        applyHead(this.$route)
      },
    },
  },

  methods: {
    applyTheme() {
      // Venue brand colour drives the design tokens (primary shades + gradient);
      // the raw venue custom CSS is appended last so it can still override anything.
      const brandCss = brandThemeCss(this.getBrandColor)
      const customCss = this.getCustomCSS || ''
      this.injectCustomCSS(`${brandCss}\n${customCss}`)
    },
    injectCustomCSS(cssString) {
      let styleTag = document.getElementById('custom-theme')
      if (!styleTag) {
        styleTag = document.createElement('style')
        styleTag.id = 'custom-theme'
        styleTag.setAttribute('type', 'text/css')
        document.head.appendChild(styleTag)
      }
      // Оновлюємо вміст
      styleTag.innerHTML = cssString
    }
  }
}
</script>

<style lang="scss">
body {
  /* The document scrolls vertically (iOS toolbar collapse depends on it);
     clip sideways overflow so nothing can pan the page horizontally. */
  overflow-x: hidden !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.Vue-Toastification__toast button {
  width: 10px;
}
</style>
